import { createContext } from "react";

export const FilterContext = createContext<[{ [x: string]: any }, (v: any) => void]>([{}, () => {
}]);

export default FilterContext;